import {Injectable} from '@angular/core';
import {Headers, Http, RequestOptions, Response} from '@angular/http';
import {Observable} from 'rxjs/Observable';

import {environment} from 'environment';

import {ManagementLevel} from 'shared/models/target-groups/management-level';

@Injectable()
export class ManagementLevelRepository {

  constructor(private http: Http) { }

  public getAllManagementLevel(): Observable<Array<ManagementLevel>> {
    const options: RequestOptions = new RequestOptions({withCredentials: true});

    return this.http.get(`${environment.targetGroups.managementLevel}`, options)
      .map((response: Response) => {
        return response.json();
      });
  }

  public getManagementLevel(id: String): Observable<ManagementLevel> {
    const options: RequestOptions = new RequestOptions({withCredentials: true});

    return this.http.get(`${environment.targetGroups.managementLevel}/${id}`)
      .map((response: Response) => {
        return response.json();
      });
  }

  public createManagementLevel(managementLevel: ManagementLevel): Observable<ManagementLevel> {
    const headers: Headers = new Headers({'Content-Type': 'application/json'});
    const options: RequestOptions = new RequestOptions({headers: headers, withCredentials: true});
    const body: String = JSON.stringify(managementLevel);

    return this.http.post(`${environment.targetGroups.managementLevel}`, body, options)
      .map((response: Response) => {
        return response.json();
      });
  }

  public updateManagementLevel(managementLevel: ManagementLevel): Observable<ManagementLevel> {
    const headers: Headers = new Headers({'Content-Type': 'application/json'});
    const options: RequestOptions = new RequestOptions({headers: headers, withCredentials: true});
    const body: String = JSON.stringify(managementLevel);

    return this.http.put(`${environment.targetGroups.managementLevel}/${managementLevel._id}`, body, options)
      .map((response: Response) => {
        return response.json();
      });
  }

  public deleteManagementLevel(managementLevel: ManagementLevel): Observable<boolean> {
    const options: RequestOptions = new RequestOptions({withCredentials: true});

    return this.http.delete(`${environment.targetGroups.managementLevel}/${managementLevel._id}`, options)
      .map((response: Response) => {
        return response.ok;
      });
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/target-groups/management-level/repositories/management-level.repository.ts